///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { validateIpBySupportedRange } from './subnetwork-validation';

export const IpIsNotMulticastValidation = (): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
        if (control.value) {
            const isValid = validateIpBySupportedRange(control.value);
            return isValid ? null : { unsupportedRange: true };
        }

        return null;
    };
};
